/**
 * PlaygroundHeader.tsx
 * Consistent header component for all playground sections
 * 
 * Uses our shared UI components to showcase them in action
 */

import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@enfomentis/ui';
import { Divider } from '@enfomentis/ui';

interface PlaygroundHeaderProps {
  title: string;
  description?: string;
  onBack?: () => void;
}

export const PlaygroundHeader: React.FC<PlaygroundHeaderProps> = ({
  title,
  description,
  onBack
}) => {

  return (
    <div className="space-y-4 p-6">
      <div className="flex items-start">
        <div className="flex items-center gap-4 w-full">
          {onBack && (
            <Button
              variant="ghost"
              size="sm"
              onPress={onBack}
              className="flex items-center gap-2 text-text-secondary hover:text-primary"
            >
              <ArrowLeft className="w-4 h-4" />
              Back
            </Button>
          )}
          <div className="flex-1">
            <h1 className="text-3xl font-bold text-text-primary">{title}</h1>
            <p className="text-text-secondary mt-1">{description}</p>
          </div>
        </div>
      </div>
      
      <Divider />
    </div>
  );
};